export const arraySum = (arr: number[]) => {
  return arr.reduce((sum, a) => sum + a, 0);
};
